<script>
    import ClientData from "./ClientData";
    import TextField from "../../common/text-field.vue";
    import HeaderCheckbox from "../../content/common/PrimeVue/HeaderCheckbox.vue";
    import SelectField from "../../common/select-field.vue";
    import Text255 from "../dynamic_fields/text255.vue";
    import Float from "../dynamic_fields/float.vue";
    import Bool from "../dynamic_fields/bool.vue";
    import Date from "../dynamic_fields/date.vue";
    import ClientImageupload from "./client-imageupload.vue";

    export default {
        name: "client-dialog-common-tab",
        components: {ClientImageupload, Date, Bool, Float, Text255, SelectField, HeaderCheckbox, TextField},
        props: {
            clientData: ClientData,
            required: true
        },
        computed: {
            translations() {
                return {
                    alias: Lang.langGet('Alias'),
                    active: Lang.langGet('Active'),
                    comment: Lang.langGet('Comment'),
                    commissioning: Lang.langGet('Commissioning'),
                    teamviewer: Lang.langGet('Teamviewer')
                }
            }
        },
        methods: {
            handleImageChange(field, value) {
                field.value = value;
            },
            handleBoolChange(field, value) {
                field.value = value ? '1' : '0';
            },
            castBool(value) {
                return value === '1';
            }
        }
    }
</script>

<template>
    <div>
        <div class="d-flex pa-5 pt-0 px-4">
            <div class="d-flex flex-column pr-4">
                <HeaderCheckbox
                    small
                    :selectMessage="translations.active"
                    :checked="clientData.active"
                    @change="({checked}) => $emit('input', 'active', checked)"
                />
            </div>
            {{translations.active}}
        </div>
        <div class="d-flex flex-row mb-2">
            <text-field class="px-4"
                :label="translations.alias"
                :value="clientData.alias"
                @input="val => $emit('input', 'alias', val)"
            />
            <text-field class="px-4"
                :label="translations.teamviewer"
                :value="clientData.teamviewer"
                @input="val => $emit('input', 'teamviewer', val)"
            />
        </div>
        <div v-for="field in clientData.dynamicFields">
            <text-field v-if="field.type === 'text255'" class="px-4"
                :label="field.name"
                v-model="field.value"
            />
            <div v-if="field.type === 'float'" class="px-4">
                <text-field
                    type="number"
                    :label="field.name"
                    :value="field.value"
                    @input="val => field.value = parseFloat(val)"
                />
            </div>
            <div v-if="field.type === 'bool'" class="px-4">
                <div class="d-flex pb-6">
                    <div class="d-flex flex-column pr-4">
                        <HeaderCheckbox
                            small
                            :selectMessage="field.name"
                            :checked="castBool(field.value)"
                            @change="({checked}) => handleBoolChange(field, checked)"
                        />
                    </div>
                    {{field.name}}
                </div>
            </div>
            <div v-if="field.type === 'date'" class="px-4 mb-4">
                <datepicker
                    v-model="field.value"
                    :label="field.name"
                    hideDetails
                    popup-used-in-modal
                />
            </div>
            <div v-if="field.type === 'fileupload'">
                <client-imageupload :title="field.name"
                    :imagePath="field.value"
                    :imageName="field.name"
                    @upload="val => handleImageChange(field, val)"
                    @delete="val => handleImageChange(field, null)"
                />
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>

